/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type Project = {
  /**
   * The creation date of the project.
   */
  createdAt: Date;
  /**
   * The ID of the project
   */
  id: string;
  /**
   * The ID of the logo asset for the project
   */
  logoAssetId?: string | undefined;
  /**
   * The name of the project
   */
  name: string;
  /**
   * The ID of the organization that owns the project
   */
  organizationId: string;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug: string;
  /**
   * The last update date of the project.
   */
  updatedAt: Date;
};

/** @internal */
export const Project$inboundSchema: z.ZodMiniType<Project, unknown> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    logo_asset_id: z.optional(z.string()),
    name: z.string(),
    organization_id: z.string(),
    slug: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "logo_asset_id": "logoAssetId",
      "organization_id": "organizationId",
      "updated_at": "updatedAt",
    });
  }),
);

export function projectFromJSON(
  jsonString: string,
): SafeParseResult<Project, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Project$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Project' from JSON`,
  );
}
